/* src/app/shared/dialogs/charge-bill-dialog/charge-bill-dialog.component.scss */
:host {
  overflow: none;
}
.dialog-container {
  width: 530px;
  position: relative;
}
.dialog-container h1 {
  font-size: 18px;
  font-weight: bold;
  line-height: 0.83;
  text-align: left;
  margin: 0;
  margin-top: 8px;
}
.dialog-container p {
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: 0.1px;
  text-align: left;
  margin-top: 32px;
}
.dialog-container .button-cancel {
  position: absolute;
  right: 0;
  top: 0;
}
.dialog-container .dialog-info {
  margin-top: 32px;
}
.dialog-container .dialog-actions {
  margin-bottom: 0px;
  margin-top: 32px;
}
.dialog-container .dialog-actions button {
  margin-left: auto;
  margin-right: auto;
}
.reasonInput {
  font-size: inherit;
  border-radius: 4px;
  line-height: inherit;
  border: solid 1px #c8c7cc;
  object-fit: contain;
  width: 200px;
  height: 36px;
}
.info-text {
  font-size: 15px;
  text-align: left;
  color: #333333;
  margin-top: 1%;
  margin-bottom: 1%;
}
.centered-image {
  padding: 30px 10px 10px 10px;
  text-align: center;
}
.centered-image img {
  height: 200px;
  width: 200px;
}
/*# sourceMappingURL=charge-bill-dialog.component.css.map */
